import { ISanityVendorConfigs } from '@rbi-ctg/menu';

export enum PluTypes {
  CONSTANT = 'constantPlu',
  IGNORE = 'ignore',
  MULTI_CONSTANT = 'multiConstantPlus',
  PARENT_CHILD = 'parentChildPlu',
  QUANTITY = 'quantityBasedPlu',
  SIZE_BASED = 'sizeBasedPlu',
}

export enum PosVendors {
  CARROLLS = 'carrols',
  CARROLS_DELIVERY = 'carrolsDelivery',
  NCR = 'ncr',
  NCR_DELIVERY = 'ncrDelivery',
  QDI = 'qdi',
  QDI_DELIVERY = 'qdiDelivery',
}

export enum PluQualifier {
  ADD = 'ADD',
  HALF = '1/2',
  NO = 'NO',
}

export interface IWithVendorConfig {
  _type?: string | null;
  type?: string | null;
  name?: string | { locale: string };
  vendorConfigs?: ISanityVendorConfigs; // TODO: remove ISanityVendorConfigs type and use proper typing
  children?: any;
}

export interface IComboWithVendorConfig extends IWithVendorConfig {
  mainItem?: IWithVendorConfig;
}
